var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconPoweredByHearXFrenchLight } from 'hx-assets';
import { cn } from 'hx-util';
export function Footer(_a) {
    var className = _a.className;
    return (_jsx("div", __assign({ className: cn('grid w-full place-items-center', className) }, { children: _jsx(IconPoweredByHearXFrenchLight, { className: "w-96 h-4" }) })));
}
